import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/skip';
import 'rxjs/add/operator/withLatestFrom';
import 'rxjs/add/operator/first';
import 'rxjs/add/operator/mergeMap';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { Action } from '@ngrx/store';
import { Effect, Actions } from '@ngrx/effects';

import * as c from '../actions/company-analysis.actions';

import { Api } from '../providers/api/api';

@Injectable()
export class CompanyAnalysisEffects {
  constructor(private actions$: Actions,
    private api: Api
  ) { }

  @Effect()
  loadCompanyAnalysis$: Observable<Action> = this.actions$
    .ofType(c.FETCH_ANALYSIS)
    .map((action: c.FetchAnalysis) => {
      return action.payload;
    })
    .mergeMap((filterSettings) => this.api.getCompanyAnalysis(filterSettings))
    .map(companyAnalysis => {
      return new c.FetchAnalysisSuccess(companyAnalysis)
    });
}



// WEBPACK FOOTER //
// ./src/effects/company-analysis.effect.ts